<template>
  <div class="orange white-border main">
    <div class="inner">
      <div class="middle">{{ t("Barqulator open") }}</div>
      <div class="gray">
        <div class="seitlich">
          <div class="orange-text">{{ barqId }}</div>
          <div class="close pointer" @click="close">
            <img src="../assets/close.svg" />
          </div>
        </div>
        <div class="white">
          <div class="content">
            <!-- Codes -->
            <template v-if="currentFrage.codes">
              <template
                v-for="(value, key, g) in currentFrage.codes"
                :key="key"
              >
                <template v-if="key == 'block'">
                  <template
                    v-for="(block, i) in currentFrage.codes.block"
                    :key="i"
                    class="codeClass"
                  >
                    <div v-for="(B, a) in block" :key="a" class="items">
                      <input
                        class="buyerInput"
                        type="text"
                        :maxlength="B.toString().length"
                        v-model="codes.block[i][a]"
                        style="text-transform: uppercase"
                        :style="customLength()"
                      />
                      <span v-if="currentFrage.fragen[i] != 'E'"
                        >C{{ i + 1 }}</span
                      >
                      <span v-else>E</span>
                    </div>
                  </template>
                </template>

                <div v-if="key == 'range'" class="items">
                  <input
                    class="buyerInput"
                    @change="change"
                    type="text"
                    v-model="codes.range[0]"
                    :maxlength="currentFrage.codes.range[0].toString().length"
                    style="text-transform: uppercase"
                    :style="customLength()"
                  />
                  <span>C{{ g + 1 }}</span>
                </div>

                <template v-if="key == 'single'">
                  <div
                    v-for="(S, a) in currentFrage.codes.single"
                    :key="a"
                    class="items"
                  >
                    <input
                      class="buyerInput"
                      @change="change"
                      type="text"
                      v-model="codes.single[a]"
                      :maxlength="S.toString().length"
                      style="text-transform: uppercase"
                    />
                    <span>C{{ g + a + 1 }}</span>
                  </div>
                </template>
              </template>
            </template>
            <!-- Bonus Codes -->
            <template v-if="currentFrage.bonus">
              <div v-for="(B, i) in currentFrage.bonus" :key="i" class="items">
                <input
                  class="buyerInput"
                  @change="change"
                  type="text"
                  v-model="bonus[i]"
                  :maxlength="B.toString().length"
                  style="text-transform: uppercase"
                />
                <span>BQ{{ i + 1 }}</span>
              </div>
            </template>
            <!-- Location -->
            <div v-if="currentFrage.location" class="items">
              <input
                @change="change"
                type="text"
                v-model="location"
                class="buyerInput longInput"
                style="text-transform: uppercase"
              />
              <span>Location</span>
            </div>
            <div @click="submit" class="items flex100">
              <button class="buyerInput submit">{{ t("SUBMIT") }}</button>
            </div>
            <div v-if="approvedText" id="approved">
              <div
                :class="
                  approvedText == 'SOLD!' || approvedText == 'VERKAUFT!'
                    ? 'sold'
                    : 'wrong_answers'
                "
              >
                {{ approvedText }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import checkCodes from "../../services/checkCodes.js";
import Fragen from "../../fragen.json";
import Dict from "../../services/dict_new.js";

export default {
  name: "Codes",
  props: {
    barqId: {
      type: String,
      default: () => "",
    },
    sprache: {
      type: String,
      default: () => "english",
    },
  },
  watch: {
    barqId: function (newVal) {
      // watch it
      this.currentFrage = this.alleAufgaben[newVal];
      // console.log(this.currentFrage);
    },
  },
  emits: ["solved", "close", "msg"],
  data() {
    return {
      approvedText: "",
      currentFrage: [],
      codes: {
        block: [[], []],
        range: [[], []],
        single: [],
      },
      location: "",
      bonus: [],
      alleAufgaben: Fragen,
      coolDownTimer: null,
    };
  },

  methods: {
    customLength() {
      var length5 = ["005", "111", "113", "117", "129", "174", "182"];
      if (length5.includes(this.barqId.split("#")[1])) return "width:70px";
      return "";
    },
    t(word) {
      return Dict(word, this.sprache);
    },
    close() {
      this.$emit("close");
    },
    submit() {
      console.log("SUBMIT");
      if (this.coolDown()) return false;
      console.log("INSIDE SUBMIT");

      var userInput = {
        name: this.barqId,
        codes: this.codes,
        bonus: this.bonus,
        location: this.location,
      };

      var Solution = this.currentFrage;
      // console.log(JSON.stringify(userInput));
      // console.log(JSON.stringify(Solution));

      // console.log(userInput);

      var solved = checkCodes(
        JSON.stringify(userInput),
        JSON.stringify(Solution)
      );

      if (solved.solved) {
        this.approvedText = this.t("SOLD!");
        this.$emit("solved", this.barqId, solved.bonus);
      } else {
        this.approvedText = this.t("Wrong answer(s)");
      }

      // this.$emit("submitCodes", codes, location, bonus);
      //check codes
    },
    calcWidth(text) {
      return text.toString().length * 20 + "px";
    },
    coolDown() {
      if (this.coolDownTimer) {
        this.$emit(
          "msg",
          this.t("please wait at least 3 seconds for your next request")
        );
        return true;
      }
      this.coolDownTimer = setTimeout(() => {
        this.coolDownTimer = null;
      }, 3000);
      return false;
    },
  },
  mounted() {
    this.currentFrage = this.alleAufgaben[this.barqId];
  },
};
</script>

<style scoped>
.close {
  border: 2px solid var(--barq-orange);
  width: 25px;
  height: 25px;
  border-radius: 50%;
  position: relative;
  background: white;
  margin-left: 10px;
}

.close:hover {
  background: var(--barq-orange);
}

.close:hover img {
  filter: brightness(10);
}

.close > img {
  width: 25px;
  position: absolute;
  top: calc(50%);
  left: calc(50%);
  transform: translateY(-50%) translateX(-50%);
}

.close:hover img {
  filter: brightness(10);
}

.flex100 {
  flex-basis: 100%;
}

#approved:before {
  border: 2px solid white;
  content: "";
  width: calc(100% - 6px);
  height: calc(100% - 6px);
  position: absolute;
  top: 1px;
  left: 1px;
  border-radius: 13px;
  pointer-events: none;
}

#approved {
  position: absolute;
  bottom: 40px;
}

#approved > div {
  color: white;
  height: 70px;
  width: 250px;
  font-size: 25px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  border-radius: 13px;
}

.sold {
  background: var(--barq-green) !important;
}

.wrong_answers {
  background: red !important;
}

.limegreen {
  background: limegreen !important;
}

.submit {
  background: white;
  width: 100px !important;
}

.submit:hover {
  background: var(--barq-orange);
  color: white;
  cursor: pointer;
}

.longInput {
  width: 200px !important;
}

.inner,
.gray {
  height: 96%;
}

.items {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  align-items: center;
  margin: 5px;
  z-index: 2;
}

.buyerInput {
  border: 3px solid var(--barq-orange);
  border-radius: 7px;
  text-align: center;
  width: 45px;
  height: 47px;
  font-size: 1.1em;
  letter-spacing: 1.5px;
}

.seitlich {
  display: flex;
  justify-content: space-between;
}

.orange-text {
  color: var(--barq-orange);
  font-size: 25px;
}

.main {
  width: 500px;
  height: 500px;
}

.gray {
  background: #f2f2f2;
  border-radius: 10px;
  padding: 10px;
}

.white {
  background: white;
  border-bottom-left-radius: 17px;
  border-bottom-right-radius: 17px;
  height: 92%;
  position: relative;
}

.content {
  background: white;
  margin-top: 10px;
  color: black;
  display: flex;
  justify-content: center;
  padding: 27px 50px;
  flex-wrap: wrap;
}

.middle {
  text-align: center;
  font-size: 1.3em;
  margin-top: -11px;
  margin-bottom: 5px;
}

.orange {
  background-color: var(--barq-orange);
  position: relative;
  border-radius: 20px;
  color: white;
  padding: 1em;
  margin: 0 auto;
}

.white-border {
  border: 2px solid white;
}
</style>
